import { render, staticRenderFns } from "./NotificationsManageTopics.vue?vue&type=template&id=6338b390"
import script from "./NotificationsManageTopics.vue?vue&type=script&lang=js"
export * from "./NotificationsManageTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports